import { EditorV2, EditorV2State, Text } from '@equip.health/ui';
import { AriaAttributes } from 'react';

interface EditorV2ValueOrNotSetProps {
  hideBorder?: boolean;
  containerTestId?: string;
  initialContent: string | null;
  readOnly?: boolean;
  stateRef: React.MutableRefObject<EditorV2State | null>;
}

const EditorV2ValueOrNotSet = ({
  initialContent,
  stateRef,
  hideBorder,
  containerTestId,
  readOnly,
  'aria-labelledby': ariaLabelledBy,
}: EditorV2ValueOrNotSetProps & Pick<AriaAttributes, 'aria-labelledby'>) => {
  return initialContent ? (
    <EditorV2
      {...(ariaLabelledBy
        ? { ariaProps: { input: { 'aria-labelledby': ariaLabelledBy } } }
        : {})}
      ariaProps={{ input: { 'aria-labelledby': ariaLabelledBy } }}
      containerTestId={containerTestId}
      hideBorder={hideBorder}
      initialContent={initialContent}
      readOnly={readOnly}
      stateRef={stateRef}
    />
  ) : (
    <Text
      {...(ariaLabelledBy ? { 'aria-labelledby': ariaLabelledBy } : {})}
      color="neutral.tertiary"
      padding="6px 0px"
    >
      Not set
    </Text>
  );
};

export default EditorV2ValueOrNotSet;
